/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
], function () {
	class UserProfile {
		constructor(glassContext) {
			this.glassContext =  glassContext;
		}

		getAPI() {
			return this;
		}
	}
	return UserProfile;
});
